import "intersection-observer";
import * as React from "react";
import { Updater, IOWidget, fromJSX } from "widgets-for-react";
import { CMSState } from "../types.gen";

export type TextBlockNestedProps = {
  index: number
  text: string
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export function TextBlockNested(
  props: TextBlockNestedProps
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) =>
    fromJSX(() => (
        <></>
        // <InView
        //   as="div"
        //   onChange={(inView) => blockInviewHandler('text', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
        //   triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
        //   threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
        //   id={`io-${options && options.key ? options.key : props.index}`}
        //   className={getClassName(options, "block_classname", "")}
        //   key={options && options.key ? options.key : `block-${props.index}`}
        // >
        //   <div className={getClassName(options, "inner_classname", "py-5")}>
        //     {props.text && (
        //       <div className={getClassName(options, "content_classname", "")}>
        //         {/* <div className={getClassName(options, "text_classname", "")} dangerouslySetInnerHTML={{ __html: props.text }} /> */}
        //         <InnerHtmlWrapper className={getClassName(options, "text_classname", "")} text={props.text} />
        //       </div>
        //     )}
        //   </div>
        // </InView>
      )
    )
}
